const WIDTH = 8;

export type ShapeProps = {
    x: number;
    y: number;
    color: string;
    width?: number;
};

export const Diamond = ({ x, y, width = WIDTH, color }: ShapeProps) => (
    <rect
        x={x - width / 2}
        y={y - width / 2}
        width={width}
        height={width}
        fill={color}
        stroke={color}
        strokeWidth={1}
        transform={`rotate(45 ${x} ${y})`} // Rotate around the center
    />
);

export const Square = ({ x, y, width = WIDTH, color }: ShapeProps) => (
    <rect
        x={x - width / 2}
        y={y - width / 2}
        width={width}
        height={width}
        fill={color}
        stroke={color}
        strokeWidth={1}
    />
);

export const Circle = ({ x, y, width = WIDTH, color }: ShapeProps) => (
    <circle
        cx={x}
        cy={y}
        r={width / 2}
        fill={color}
        stroke={color}
        strokeWidth={2}
        pointerEvents="none"
    />
);
